const imgListTop6 = "imgListTop6.json";
const imgList = "imgList.json";

// will be used in getFileContent to save file names in constants
export { imgList, imgListTop6 };